import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import Tasks from 'APP/Tasks';
import { User } from 'STORE/Users/User/User';

export interface IGroupFormMembersPresenter {
  cursor?: string;
  candidates: User[];
  isLoading: boolean;
  hasMore: boolean;
  loadMore(): Promise<void>;
  init(): Promise<void>;
}

export const useGroupFormMembersPresenter = (): IGroupFormMembersPresenter => {
  const presenter = useLocalObservable<IGroupFormMembersPresenter>(() => ({
    cursor: '',
    candidates: [],
    isLoading: false,

    async init(): Promise<void> {
      presenter.cursor = undefined;
      presenter.candidates = [];
      await presenter.loadMore();
    },

    get hasMore(): boolean {
      return !!presenter.cursor;
    },

    async loadMore(): Promise<void> {
      presenter.isLoading = true;

      const { users, cursor } = await Tasks.group.getAddUsersToGroup({ cursor: presenter.cursor });

      presenter.candidates = [...this.candidates, ...users];
      presenter.isLoading = false;

      presenter.cursor = cursor;
    },
  }));

  useEffect(() => {
    if (presenter.isLoading) {
      return;
    }
    presenter.init();
  }, []);

  return presenter;
};
